/**
 * Created by chenggong on 2018/3/29.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import state from './states'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js